import { useEffect, type ReactNode } from 'react';

/** Modal panel over the game. Escape or the close button dismisses it. */
export function Sheet({ title, subtitle, onClose, children, wide }: { title: string; subtitle?: ReactNode; onClose: () => void; children: ReactNode; wide?: boolean }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="overlay" onPointerDown={(e) => e.target === e.currentTarget && onClose()}>
      <section className={wide ? 'sheet wide' : 'sheet'} role="dialog" aria-modal="true" aria-labelledby="sheet-title">
        <header className="sheet-head">
          <div>
            <h2 id="sheet-title">{title}</h2>
            {subtitle && <p className="muted small-print">{subtitle}</p>}
          </div>
          <button className="btn ghost" onClick={onClose} aria-label="Close">Close</button>
        </header>
        <div className="sheet-body">{children}</div>
      </section>
    </div>
  );
}
